// Discloses the Cc / Bcc recipient fields behind a single "Cc/Bcc" toggle, the
// standard email-client pattern (the common reply needs only "To", so Cc + Bcc
// stay tucked away until asked for). Mirrors password_toggle_controller's shape:
// a lone toggle method flips a class + the toggle button's accessible state.
//
// Progressive enhancement: the Cc/Bcc fields live in the DOM unconditionally
// (so the form submits identically with or without JS) — this controller only
// shows/hides them via the `d-none` class. The server seeds the initial state
// (_recipient_fields.html.erb:74 renders `d-none` when the cluster starts closed,
// and omits it when start_open is true); connect() re-applies open-value on JS
// boot and toggle() flips it thereafter.
//
// The fields start revealed when the server seeded them (data-recipient-
// disclosure-open-value="true" — an edit form carrying Cc, or a reply-all that
// prefilled Cc) so a member never loses sight of recipients they already have.
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['fields', 'toggle']
  static values = { open: Boolean }

  connect() {
    this.apply(this.openValue)
  }

  toggle(event) {
    event.preventDefault()
    this.apply(this.fieldsTarget.classList.contains('d-none'))
  }

  apply(open) {
    this.fieldsTarget.classList.toggle('d-none', !open)
    if (this.hasToggleTarget) {
      this.toggleTarget.setAttribute('aria-expanded', open ? 'true' : 'false')
    }
  }
}
